import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Validators } from '@peca/commons';
import { DesignSystemModule } from '@peca/design-system';

@Component({
  selector: 'peca-monitoring-search',
  templateUrl: './monitoring-search.component.html',
  styleUrl: './monitoring-search.component.scss',
  imports: [CommonModule, DesignSystemModule, ReactiveFormsModule],
})
export class MonitoringSearchComponent {
  @Output()
  search = new EventEmitter();

  today = new Date();

  lastWeek = new Date(this.today.getTime() - 7 * 24 * 60 * 60 * 1000);

  form = new FormGroup({
    clientId: new FormControl('store-movida', [Validators.required]),
    plate: new FormControl(''),
    range: new FormControl({
      startDate: this.lastWeek.toISOString().substring(0, 10),
      endDate: this.today.toISOString().substring(0, 10),
    }),
    withResult: new FormControl(''),
  });

  onClickSearch() {
    if (this.form.invalid) {
      return;
    }

    const { clientId, withResult, range, plate } = this.form.value;

    this.search.emit({
      startDate: range?.startDate,
      endDate: range?.endDate,
      withResult: withResult ? JSON.parse(withResult) : null,
      clientId: clientId,
      plate: plate
    });
  }
}
